import { CardTypes } from '.';

export const SetCard = (data: any) => ({
 type: CardTypes.SET_CARD_DATA,
 data,
});
